import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const CapabilitiesContext = createContext(null);

export function CapabilitiesProvider({ children }) {
    const { user } = useAuth();
    const [caps, setCaps] = useState(null);

    const load = useCallback(async () => {
        if (!user) { setCaps(null); return; }
        try {
            const { data } = await api.get("/auth/capabilities");
            setCaps(data);
        } catch (e) {
            setCaps(null);
        }
    }, [user]);

    useEffect(() => { load(); }, [load]);

    return (
        <CapabilitiesContext.Provider value={{ caps, refresh: load }}>
            {children}
        </CapabilitiesContext.Provider>
    );
}

export function useCapabilities() {
    return useContext(CapabilitiesContext) || { caps: null, refresh: () => {} };
}
